import type { UserPostsMessage } from '@/entities/discovery';
import { UserMessageBubble } from './primitives';

export const UserMessagePosts = ({ message }: { message: UserPostsMessage }) => {
  const postList = message.content.post_list;

  return (
    <UserMessageBubble>
      <div className="flex flex-wrap gap-1.5 py-1">
        {postList.map((post) => (
          <img
            key={post.post_id}
            src={post.poster_url}
            className="bg-background/10 h-24 w-16 rounded-md object-cover"
          ></img>
        ))}
      </div>
    </UserMessageBubble>
  );
};
